import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "No matching data", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_ctx.element.options && _ctx.element.options)
    ? (_openBlock(), _createBlock(_component_VueMultiselect, _mergeProps({
        key: 0,
        modelValue: _ctx.selectedItems,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems) = $event)),
        options: _ctx.computedOptions,
        multiple: _ctx.element.multiSelect,
        hideSelected: true,
        showLabels: false,
        "internal-search": true,
        tagPlaceholder: "",
        placeholder: _ctx.element.placeholder,
        trackBy: "value",
        label: "label",
        limitText: (count) => `+ ${count}`,
        limit: _ctx.limitSelectedItems,
        openDirection: "bottom"
      }, _ctx.$attrs), {
        option: _withCtx(({ option }) => [
          (option.value === 'select_all' && !_ctx.isAllSelected)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, " Select All "))
            : (option.value === 'remove_all')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Remove All"))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(option.label), 1))
        ]),
        noResult: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 16, ["modelValue", "options", "multiple", "placeholder", "limitText", "limit"]))
    : _createCommentVNode("", true)
}